import { Skeleton } from '@mui/material'
import { IntegrationCard } from './integration-card'

export const SkeletonCard = () => (
  <IntegrationCard>
    <IntegrationCard.Title>
      <Skeleton variant="rectangular" width={20} height={20} />
      <Skeleton width="60%" height={20} />
    </IntegrationCard.Title>
    <IntegrationCard.Container>
      <IntegrationCard.Content>
        <div className="w-[120px]">
          <Skeleton width="40%" height={32} />
          <Skeleton width="30%" height={12} />
        </div>
      </IntegrationCard.Content>
    </IntegrationCard.Container>
  </IntegrationCard>
)
